export default "__VITE_ASSET__B4zZ9U3I__"